import React, { useState } from 'react';
import axios from 'axios';

const VideoPlayer = () => {
  const [videoSrc, setVideoSrc] = useState('');

  const fetchVideo = async () => {
    try {
      const response = await axios.get('https://assessnhiresorageaccount.blob.core.windows.net/videorecordings/f334c7a9-8593-4668-806f-9bb42d77cb95.webm', {
        responseType: 'blob',
      });

      const url = URL.createObjectURL(response.data);
      setVideoSrc(url);
    } catch (error) {
      console.error('Error fetching the video', error);
    }
  };

  return (
    <div>
      <button onClick={fetchVideo}>Load Video</button>
      {videoSrc && (
        <video src={videoSrc} controls preload="auto">
          Your browser does not support the video tag.
        </video>
      )}
    </div>
  );
};

export default VideoPlayer;
